module.exports = __webpack_public_path__ + "fromBrideToFather-we-p.cc27455f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToFather-we-p.jpg
// module id = MRE3
// module chunks = 0